/*
*   全局方法
*
* */

(function (window) {
  /*设备信息*/
  window.platformFn = function () { var ua = navigator.userAgent.toLowerCase(); if (ua.indexOf("window") != -1) { return "windows" } else if (ua.indexOf("ipad") != -1) { return "ipad" } else if (ua.indexOf("ipod") != -1) { return "ipod" } else if (ua.indexOf("iphone") != -1) { return "iphone" } else if (ua.indexOf("mac") != -1) { return "apple" } else if (ua.indexOf("android") != -1) { return "android" } else if (ua.indexOf("linux") != -1) { return "linux" } else if (ua.indexOf("nokia") != -1) { return "nokia" } else if (ua.indexOf("blackberry") != -1) { return "blackberry" } else if (ua.indexOf("freebsd") != -1) { return "freebsd" } else if (ua.indexOf("netbsd") != -1) { return "netbsd" } else if (ua.indexOf("openbsd") != -1) { return "openbsd" } else if (ua.indexOf("opensolaris") != -1) { return "opensolaris" } else if (ua.indexOf("sunos") != -1) { return "sunos" } else if (ua.indexOf("os\/2") != -1) { return "os2" } else if (ua.indexOf("beos") != -1) { return "beos" } else if (ua.indexOf("htc") != -1) { return "htc" } else if (ua.indexOf("windows phone") != -1) { return "windows phone" } else if (ua.indexOf("win") != -1) { return "windows" } };
  let origin = location.origin;
  window._wxConfigData = {
    iosConfigUrl: location.href.split('#')[0],
    _appId: "wx0790671b08e879be",
    'login_url': encodeURIComponent(origin + "/login/wx?v=1"),
    'payment_url': encodeURIComponent(origin + "/wxpay?v=1")
  };
  window.__shareData = {
    title: "会奖小秘书",
    desc: "办会更高效，参会更简便",
    link: location.origin + "/",
    imgUrl: location.origin + "/static/logo.png",
    _success: function () {

    }
  };

  window.wx_share_trigger = function () {
    if (!wx) {
      return
    }
    // wx.updateTimelineShareData({
    //   title: __shareData.title || "title",
    //   link: __shareData.link || "link",
    //   desc: __shareData.desc || "desc",
    //   imgUrl: __shareData.imgUrl || "imgUrl",
    //   success: function (res) {
    //     //	alert('已分享');
    //     console.log('updateTimelineShareData success')
    //     console.log(res);
    //     console.log('end')
    //     if (typeof __shareData._success === 'function') {
    //       __shareData._success()
    //     }
    //   },
    //   complete: function (res) {
    //     console.log('updateTimelineShareData complete')
    //     console.log(res);
    //     console.log('end')
    //   },
    //   cancel: function (res) {
    //     console.log('updateTimelineShareData cancel')
    //     console.log(res);
    //     console.log('end')
    //   },
    //   fail: function (res) {
    //     console.log('updateTimelineShareData fail')
    //     console.log(res);
    //     console.log('end')
    //   }
    // });
    // wx.updateAppMessageShareData({
    //   title: __shareData.title || "title",
    //   link: __shareData.link || "link",
    //   desc: __shareData.desc || "desc",
    //   imgUrl: __shareData.imgUrl || "imgUrl",
    //   success: function (res) {
    //     //	alert('已分享');
    //     console.log('updateAppMessageShareData success')
    //     console.log(res);
    //     console.log('end')
    //     if (typeof __shareData._success === 'function') {
    //       __shareData._success()
    //     }
    //   },
    //   complete: function (res) {
    //     console.log('updateAppMessageShareData complete')
    //     console.log(res);
    //     console.log('end')
    //   },
    //   cancel: function (res) {
    //     console.log('updateAppMessageShareData cancel')
    //     console.log(res);
    //     console.log('end')
    //   },
    //   fail: function (res) {
    //     console.log('updateAppMessageShareData fail')
    //     console.log(res);
    //     console.log('end')
    //   }
    // });
    wx.onMenuShareTimeline({
      title: __shareData.title || "title",
      link: __shareData.link || "link",
      desc: __shareData.desc || "desc",
      imgUrl: __shareData.imgUrl || "imgUrl",
      success: function (res) {
        //	alert('已分享');
        console.log('onMenuShareTimeline success')
        console.log(res);
        console.log('end')
        if (typeof __shareData._success === 'function') {
          __shareData._success()
        }
      },
      complete: function (res) {
        console.log('onMenuShareTimeline complete')
        console.log(res);
        console.log('end')
      },
      cancel: function (res) {
        console.log('onMenuShareTimeline cancel')
        console.log(res);
        console.log('end')
      },
      fail: function (res) {
        console.log('onMenuShareTimeline fail')
        console.log(res);
        console.log('end')
      }
    });
    wx.onMenuShareAppMessage({
      title: __shareData.title || "title",
      link: __shareData.link || "link",
      desc: __shareData.desc || "desc",
      imgUrl: __shareData.imgUrl || "imgUrl",
      success: function (res) {
        //	alert('已分享');
        console.log('onMenuShareAppMessage success')
        console.log(res);
        console.log('end')
        if (typeof __shareData._success === 'function') {
          __shareData._success()
        }
      },
      complete: function (res) {
        console.log('onMenuShareAppMessage complete')
        console.log(res);
        console.log('end')
      },
      cancel: function (res) {
        console.log('onMenuShareAppMessage cancel')
        console.log(res);
        console.log('end')
      },
      fail: function (res) {
        console.log('onMenuShareAppMessage fail')
        console.log(res);
        console.log('end')
      }
    });

  }
  /*
      是否为微信浏览器
  */
  window.isWeiXin = function () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  };
  /*获取现在秒级时间戳
  *  __getNowTimestamp();  获取现在的时间戳
  * __getNowTimestamp("2016-05-04");  转时间戳
  * */
  window.__getNowTimestamp = function (t) {
    var date = t ? new Date(t.replace(/-/g, "/")) : new Date();
    var timer = Math.round(date.getTime() / 1000).toString();
    return parseInt(timer)
  };
  /*js秒级时间戳转date
  * __format(stamp,mat)  stamp => 时间戳(选填)  mat => yyyy-MM-dd hh:mm:ss分割符(选填)
  * */
  window.__format = function (stamp, mat) {
    var timeStamp = stamp || __getNowTimestamp();
    var format = mat || "yyyy-MM-dd";
    var thisTime = new Date(parseInt(timeStamp) * 1000);
    var date = {
      "M+": thisTime.getMonth() + 1,
      "d+": thisTime.getDate(),
      "h+": thisTime.getHours(),
      "m+": thisTime.getMinutes(),
      "s+": thisTime.getSeconds(),
      "q+": Math.floor((thisTime.getMonth() + 3) / 3),
      "S+": thisTime.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (thisTime.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1
          ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
      }
    }
    return format;
  };

  /*计算天数
  * DateMinus(sDate,eDate) => 必传"2017-05-06"
  * */
  window.DateMinus = function (sDate, eDate) {
    var sdate = new Date(sDate.replace(/-/g, "/"));
    var now = new Date(eDate.replace(/-/g, "/"));
    var days = now.getTime() - sdate.getTime();
    var day = parseInt(days / (1000 * 60 * 60 * 24));
    return day;
  };
  /*  计算年龄
       __GetAge(strBirthday) strBirthday => 必传"2017-05-06"
   * */
  window.__GetAge = function (strBirthday) {
    var returnAge;
    var strBirthdayArr = strBirthday.split("-");
    var birthYear = strBirthdayArr[0];
    var birthMonth = strBirthdayArr[1];
    var birthDay = strBirthdayArr[2];

    d = new Date();
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth() + 1;
    var nowDay = d.getDate();

    if (nowYear == birthYear) {
      returnAge = 0;//同年 则为0岁
    }
    else {
      var ageDiff = nowYear - birthYear; //年之差
      if (ageDiff > 0) {
        if (nowMonth == birthMonth) {
          var dayDiff = nowDay - birthDay;//日之差
          if (dayDiff < 0) {
            returnAge = ageDiff - 1;
          }
          else {
            returnAge = ageDiff;
          }
        }
        else {
          var monthDiff = nowMonth - birthMonth;//月之差
          if (monthDiff < 0) {
            returnAge = ageDiff - 1;
          }
          else {
            returnAge = ageDiff;
          }
        }
      }
      else {
        returnAge = null;//返回null 表示出生日期输入错误 晚于今天
      }
    }

    return returnAge;//返回周岁年龄

  };

  /*表单验证*/
  window.FormValida = {
    form_checkUser: function (str) {
      var re = /^[\u4e00-\u9fa5_a-zA-Z]+$/;
      if (re.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    form_checkMobile: function (str) {
      var re = /^1\d{10}$/
      if (re.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    form_checkTel: function (str) {
      var re = /^0\d{2,3}-?\d{7,8}$/;
      if (re.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    form_checkEmail: function (str) {
      var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      if (re.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    form_IdCardNo: function (num) {
      var num = num.toUpperCase();
      //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
      if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
        alert('输入的身份证号长度不对，或者号码不符合规定！\n15位号码应全为数字，18位号码末位可以为数字或X。');
        return false;
      }
      //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      //下面分别分析出生日期和校验位
      var len, re;
      len = num.length;
      if (len == 15) {
        re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
        var arrSplit = num.match(re);
        //检查生日日期是否正确
        var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
        var bGoodDay;
        bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
        if (!bGoodDay) {
          alert('输入的身份证号里出生日期不对！');
          return false;
        }
        else {
          //将15位身份证转成18位
          //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var nTemp = 0, i;
          num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
          for (i = 0; i < 17; i++) {
            nTemp += num.substr(i, 1) * arrInt[i];
          }
          num += arrCh[nTemp % 11];
          return num;
        }
      }
      if (len == 18) {
        re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        var arrSplit = num.match(re);
        //检查生日日期是否正确
        var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
        var bGoodDay;
        bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
        if (!bGoodDay) {
          alert('输入的身份证号里出生日期不对！');
          return false;
        }
        else {
          //检验18位身份证的校验码是否正确。
          //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          var valnum;
          var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var nTemp = 0, i;
          for (i = 0; i < 17; i++) {
            nTemp += num.substr(i, 1) * arrInt[i];
          }
          valnum = arrCh[nTemp % 11];
          if (valnum != num.substr(17, 1)) {
            alert('18位身份证的校验码不正确！应该为：' + valnum);
            return false;
          }
          return num;
        }
      }
    }
  }
  /*$G() URL */
  window.$G = function () { var Url = top.window.location.href; var u, g, StrBack = ''; if (arguments[arguments.length - 1] == "#") { u = Url.split("#") } else { u = Url.split("?") } if (u.length == 1) { g = '' } else { g = u[1] } if (g != '') { gg = g.split("&"); var MaxI = gg.length; str = arguments[0] + "="; for (i = 0; i < MaxI; i++) { if (gg[i].indexOf(str) == 0) { StrBack = gg[i].replace(str, ""); break } } } return StrBack }

})(window);




// WEBPACK FOOTER //
// ./src/assets/js/global.js